<template>
  <div>
    <h2>Alerts for routing status</h2>
    <p>
      Configure your alerts to track routing status mismatches and BGP events
      associated with your resources.
    </p>
    <img
      src="../../assets/exclamation-icon.svg"
      class="icon"
      alt="exclamation"
    />
    <div v-if="selectedAccount">
      <p>You do not have alerts yet for the selected member account.</p>
      <button class="btn btn-primary" @click="showCreateAlertModal">
        Create alert
      </button>
    </div>
    <p v-else>
      To create an alert, there must be a selected member account.
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WithoutAlertsRoutingStatus',

  computed: {
    ...mapGetters('dataStore', ['selectedAccount'])
  },

  methods: {
    showCreateAlertModal() {
      this.$emit('showCreateAlertModal');
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
}
button {
  margin-top: 2rem;
}
</style>
